import React from "react";
import "./Hobbies.css";
import { useEffect } from "react";
import { Container } from "react-bootstrap";

function Hobbies() {
  const modelViewerStyle = {
    width: "100%",
    height: "800px",
    marginTop: "-20rem",
  };
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <div className="main__container">
        <p className="center__text">
          Explore My Creative Hobbies and Adventures
        </p>
      </div>
      <div>
        <br />
        <h1 className="conquer">Conquer Your Passions</h1>
        <div className="image__sect">
          <img
            className="hobbies__image"
            src="images/hob.avif"
            alt="Edited_by_piyush_agarwal"
          />
          <p className="hobbies__img__text">
            <p className="sub__head__text">
              <h4>Photo Editing </h4>
              Along with photography, editing photos is one of my hobbies. I
              enjoy capturing scenes of nature, landscapes, and historic
              structures.
            </p>

            <p className="sub__head__text">
              <h4>Travelling</h4>I enjoy traveling; I've been to places like, Varanasi, Ayodhya, Mirzapur,
              Jammu & Kashmir, Haridwar, Agra, Kota, Ajmer, Udaipur, Mount Abu,
              Chittorgarh, Dholpur, Mathura, Jaisalmer, Bikaner, Pokhran, and
              Tanot in my own nation.{" "}
            </p>

            <p className="sub__head__text">
              <h4>Football</h4>
              My favorite game, which I have played since I was in school, is
              football. My favorite football player is Lionel Messi.
            </p>
          </p>
        </div>
      </div>
      <br />
      
      <Container>
        <p className="sentence"> "Life is 10% what happens to us and 90% how we react to it."</p>
      </Container>

      <br /> <br />
      <div>
        <h2 className="hobby__highlights">Hobby Highlights</h2>
        <div className="container">
          <div className="row">
            {[
              "images/h/h5.avif",
              "images/h/h6.avif",
              "images/h/h7.avif",
              "images/h/h10.avif",
              "images/h/img-photo.jpg",
              "images/h/hawa.jpeg",
              "images/h/h3.jpg",
              "images/h/h2.avif",
              
            ].map((imageSource, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div className="image-container">
                  <img
                    src={imageSource}
                    alt={`Image ${index + 1}`}
                    className="img-fluid"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hobbies;
